<template>
  <div
    class="d-flex"
    :class="collectionClass || $style.row"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { StyleClass } from '../types/StyleClass';

export default Vue.extend({
  props: {
    collectionClass: {
      type: [String, Array, Object] as PropType<StyleClass>,
      default: undefined,
    },
  },
});
</script>

<style lang="scss" module>
@import '../styles/variables-entry';

.row {
  gap: 1rem;
}
</style>
